export default __webpack_public_path__ + "static/media/1cc2832389fe9e9623ff669881291f66.svg";